import { createApiReducer } from 'reacticoon/reducer'
import { postLoginMfa } from './actions'

const loginMfaReducer = createApiReducer(postLoginMfa)

export default loginMfaReducer
